import React, { useEffect, useState } from 'react';
import './WalletInfo.css';
import GameHeader from '../header/header';
import "../../Pages/Home/home.css"
import ApiService from '../../services/apiService';
import { ClipLoader } from 'react-spinners';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { MdHistoryToggleOff } from "react-icons/md";
const WithdrawBalance = () => {
    const [crypto, setCrypto] = useState('USDC');
    const [network, setNetwork] = useState('ERC20');

    const [formData, setFormData] = useState({
        receiptAddress: '',
        phoneNumber: '',
        name: '',
        amount: '',
        loginPassword: '',
    });
    const [showPasswords, setShowPasswords] = useState({
        login: false,
    })
    const [loader, setLoader] = useState(false);
    const [userData, setItems] = useState();
    const apiService = new ApiService();
    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            fetchuserData(items)
        }
    }, []);
    const fetchuserData = async (items) => {
        try {
            const params = new URLSearchParams();
            params.append('id', items?.nameid);
            const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            setItems(res?.data[0]);
            const walletparam = new URLSearchParams();
            walletparam.append('userId', items?.nameid);
            const walletRes = await apiService.getApiParamater('GET_WALLET_DETAILS', `?${walletparam.toString()}`);
            let walletdata = walletRes?.data[0]
            setFormData((prev) => ({
                ...prev,
                receiptAddress: walletdata?.receiptAddress,
                phoneNumber: walletdata?.phoneNumber,
                name: walletdata?.name,
            }));
            setCrypto(walletdata?.cryptocurrency)
            setNetwork(walletdata?.paymentNetwork)
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const togglePasswordVisibility = (field) => {
        setShowPasswords(prev => ({ ...prev, [field]: !prev[field] }));
    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleWithdraw = () => {
        setLoader(true)
        debugger
        if (!formData?.amount) {
            toast.warning("Please Enter withdrawal amount")
            setLoader(false)
            return
        } else if (!formData?.loginPassword) {
            toast.warning("Please Enter withdrawal password")
            setLoader(false)
            return
        } else if (formData?.loginPassword != userData?.widthDrawPassword) {
            toast.warning("Please Enter Correct withdrawal password")
            setLoader(false)
            return
        } if (userData?.playedGames < userData?.totalGames) {
            toast.warning("Please complete your daily optimizations in order to submit withdrawals, thank you!")
            setLoader(false)
            return
        } else {
            toast.warning("You withdrawal Request Submited successfully, thank you!")
            setLoader(false)
            return
        }
    }
    return (
        <div className="obtibg">
            <GameHeader />
            <div className='optimizeBox  mt-lg-5 p-lg-4'>
                <div className='d-flex justify-content-between'>
                    <div className="wallet-header">
                        <h2>Withdrawal</h2>
                    </div>
                    <div>
                        <MdHistoryToggleOff size={30} color='#fff' />

                    </div>
                </div>

                <div className="balance-box mt-3">
                    <p>Account Balance</p>
                    <h1 className='text-white' style={{ fontWeight: '700' }}>USDC {userData?.balance.toFixed(2)}</h1>
                </div>

                <div className="">
                    <div className="wallet-header">
                        <h2>Withdrawal Method </h2>
                    </div>
                    <h5>Transfer To Crypto Wallet Address</h5>
                    <div>{formData?.name}</div>
                    <div>{network}</div>
                    <div>{formData?.receiptAddress}</div>
                    <div>{formData?.phoneNumber}</div>
                </div>

                <div className="wallet-field my-4">
                    <h3>Withdrawal Amount</h3>
                    <input
                        type="number"
                        className="form-control p-2"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                    />
                </div>

                <div className="wallet-field">
                    <h3>Withdrawal Password</h3>
                    <div className="input-group">
                        <input
                            type={showPasswords.login ? "text" : "password"}
                            className="form-control"
                            value={formData.loginPassword}
                            onChange={(e) => setFormData({ ...formData, loginPassword: e.target.value })}
                        />
                        <span className="input-group-text" onClick={() => togglePasswordVisibility('login')}>
                            {showPasswords.login ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                </div>

                <div className='center p-3 '>
                    {loader === true ?
                        <button class="btn btn-scondary center w-100 btn-lg " type="button">
                            <ClipLoader color='#fff' />
                        </button>
                        :
                        <button class="btn btn-primary" onClick={handleWithdraw}>Withdrawal</button>
                    }
                </div>
                <div>**Withdrawal processing time will be within one hour.</div>
                <div className="wallet-header mt-5">
                    <h2>Withdrawal Method </h2>
                </div>
                <div>1. Fill in the withdrawal amount</div>
                <div className='my-3'>2. Fill in the withdrawal password</div>
                <div>You may proceed to the withdrawal now! Kindly consult our agent support if you have any</div>

            </div>
        </div>
    );
};

export default WithdrawBalance;